import { CcfHome } from '../ccf-home/ccf-home';

/* eslint-disable-next-line */
export interface CcfDayPlannerProps {}

/**
 * Component displays day planner static image for demo
 * @param props -CcfDayPlannerProps
 * @returns day planner static image for demo
 * ```
 * @example
 * const inboxCardState = 1
 * <CcfDayPlanner inboxCardState={inboxCardStateVal}/>
 * ```
 */
export function CcfDayPlanner(props: CcfDayPlannerProps) {
  return (
    <div style={{ width: '100%' }}>
      <CcfHome />
    </div>
  );
}
